export default "__VITE_ASSET__0e9a3833__"